// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.session.ProxyServiceInfo
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSClass.vm

import { ProxyType } from "abweb/dto/generated/proxy/ProxyType";
export class ProxyServiceInfo {
  static createProxyServiceInfo(apiName, isDefault, isDirect, label, name, proxyRoot, type) {
    const retVal = new ProxyServiceInfo();
    retVal.initProxyServiceInfo(apiName, isDefault, isDirect, label, name, proxyRoot, type);
    return retVal;
  }

  /** Do NOT invoke directly, instead use strongly typed createProxyServiceInfo factory method */
  constructor() {}

  // @ts-ignore: noUnusedLocals
  getJavaClass() {
    return "cawads.ProxyServiceInfo";
  }
  initFromJson(json, deserializeContext) {
    this.initProxyServiceInfo(json.apiName != null ? json.apiName : null, json.isDefault, json.isDirect, json.label != null ? json.label : null, json.name != null ? json.name : null, json.proxyRoot != null ? json.proxyRoot : null, json.type != null ? ProxyType.fromJson(json.type) : null);
  }
  initProxyServiceInfo(apiName, isDefault, isDirect, label, name, proxyRoot, type) {
    this._apiName = apiName;
    this._isDefault = isDefault;
    this._isDirect = isDirect;
    this._label = label;
    this._name = name;
    this._proxyRoot = proxyRoot;
    this._type = type;
  }
  toTSOG(result, serializeContext) {
    const retVal = result;
    retVal["apiName"] = this._apiName;
    retVal["isDefault"] = this._isDefault;
    retVal["isDirect"] = this._isDirect;
    retVal["label"] = this._label;
    retVal["name"] = this._name;
    retVal["proxyRoot"] = this._proxyRoot;
    retVal["type"] = this._type;
    return retVal;
  }
  get apiName() {
    return this._apiName;
  }
  set apiName(value) {
    this._apiName = value;
  }
  get isDefault() {
    return this._isDefault;
  }
  set isDefault(value) {
    this._isDefault = value;
  }
  get isDirect() {
    return this._isDirect;
  }
  set isDirect(value) {
    this._isDirect = value;
  }
  get label() {
    return this._label;
  }
  set label(value) {
    this._label = value;
  }
  get name() {
    return this._name;
  }
  set name(value) {
    this._name = value;
  }
  get proxyRoot() {
    return this._proxyRoot;
  }
  set proxyRoot(value) {
    this._proxyRoot = value;
  }
  get type() {
    return this._type;
  }
  set type(value) {
    this._type = value;
  }
}
//# sourceMappingURL=ProxyServiceInfo.js.map
